class CustomHeader {
    constructor() {
      this.header = document.querySelector('[data-section-type="header"]');
      if (!this.header) return;
      
      this.isTransparent = this.header.classList.contains('site-header--transparent');
      this.desktopNav = this.header.querySelector('[data-desktop-nav]');
      this.mobileNav = this.header.querySelector('[data-mobile-nav]');
      this.mobileMenuTrigger = this.header.querySelector('[data-mobile-menu-trigger]');
      this.mobileMenu = document.querySelector('[data-mobile-menu]');
      this.submenus = document.querySelectorAll('[data-submenu]');
      this.mobileMenuClose = document.querySelector('.mobile-menu__close');
      this.submenuClose = document.querySelectorAll('.submenu-close');
      this.backgroundBlur = null;
      
      this.init();
    }
  
    init() {
      this.initScrollHandler();
      this.initMegaMenus();
      this.initMobileMenu();
      this.initCloseButtons();
    }
  
    initScrollHandler() {
      let lastScroll = 0;
      const scrollThreshold = 10;
       
      if (this.isTransparent && window.pageYOffset <= scrollThreshold) {
        this.header.classList.add('site-header--transparent');
        this.header.classList.remove('is-scrolled');
      } else if (window.pageYOffset > scrollThreshold) {
        this.header.classList.remove('site-header--transparent');
        this.header.classList.add('is-scrolled');
      }
      
      window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;
        
        if (currentScroll > scrollThreshold) {
          this.header.classList.add('is-scrolled');
          this.header.classList.remove('site-header--transparent');
        } else {
          this.header.classList.remove('is-scrolled');
          if (this.isTransparent) {
            this.header.classList.add('site-header--transparent');
          }
        }
        
        lastScroll = currentScroll;
      });
    }
  
    initMegaMenus() {
      const megaMenuTriggers = document.querySelectorAll('[data-mega-menu-trigger]');
      const megaMenus = document.querySelectorAll('[data-mega-menu]');
      let activeMenu = null;
      let activeMenuTimeout;
   
      megaMenus.forEach(menu => {
        const swiperElement = menu.querySelector('.mega-menu-swiper');
        if (swiperElement && typeof Swiper !== 'undefined') {
          try {
            new Swiper(swiperElement, {
              slidesPerView: 7,
              spaceBetween: 20,
              navigation: {
                nextEl: swiperElement.querySelector('.swiper-button-next'),
                prevEl: swiperElement.querySelector('.swiper-button-prev'),
              },
              breakpoints: {
                320: {
                  slidesPerView: 2,
                  spaceBetween: 10
                },
                480: {
                  slidesPerView: 3,
                  spaceBetween: 15
                },
                768: {
                  slidesPerView: 4,
                  spaceBetween: 15
                },
                990: {
                  slidesPerView: 5,
                  spaceBetween: 20
                },
                1200: {
                  slidesPerView: 6,
                  spaceBetween: 20
                },
                1400: {
                  slidesPerView: 7,
                  spaceBetween: 20
                }
              }
            });
          } catch (error) {
            console.warn('Swiper initialization failed:', error);
          }
        }
      });
  
      megaMenuTriggers.forEach(trigger => {
        const menuItem = trigger.closest('.has-megamenu');
        if (!menuItem) return;
        
        const megaMenu = menuItem.querySelector('[data-mega-menu]');
        if (!megaMenu) return;
  
        const handleMouseEnter = (e) => { 
          const triggerRect = trigger.getBoundingClientRect();
          if (e.clientY > triggerRect.bottom) return;
  
          clearTimeout(activeMenuTimeout);
          
          if (activeMenu && activeMenu !== megaMenu) {
            activeMenu.classList.remove('is-active');
            activeMenu.closest('.has-megamenu')?.classList.remove('is-active');
          }
  
          megaMenu.classList.add('is-active');
          menuItem.classList.add('is-active');
          activeMenu = megaMenu;
        };
  
        const handleMouseLeave = (e) => { 
          const megaMenuRect = megaMenu.getBoundingClientRect();
          const isMovingToMegaMenu = e.clientY >= megaMenuRect.top && 
                                    e.clientY <= megaMenuRect.bottom &&
                                    e.clientX >= megaMenuRect.left && 
                                    e.clientX <= megaMenuRect.right;
  
          if (!isMovingToMegaMenu) {
            activeMenuTimeout = setTimeout(() => {
              megaMenu.classList.remove('is-active');
              menuItem.classList.remove('is-active');
              activeMenu = null;
            }, 100);
          }
        };
  
        trigger.addEventListener('mouseenter', handleMouseEnter);
        menuItem.addEventListener('mouseleave', handleMouseLeave);
         
        megaMenu.addEventListener('mouseenter', () => {
          clearTimeout(activeMenuTimeout);
        });
  
        megaMenu.addEventListener('mouseleave', (e) => { 
          const triggerRect = trigger.getBoundingClientRect();
          const isMovingToTrigger = e.clientY <= triggerRect.bottom &&
                                   e.clientX >= triggerRect.left &&
                                   e.clientX <= triggerRect.right;
  
          if (!isMovingToTrigger) {
            activeMenuTimeout = setTimeout(() => {
              megaMenu.classList.remove('is-active');
              menuItem.classList.remove('is-active');
              activeMenu = null;
            }, 100);
          }
        });
         
        trigger.addEventListener('click', (e) => {
          if (window.innerWidth < 990) {
            e.preventDefault();
            megaMenu.classList.toggle('is-active');
            menuItem.classList.toggle('is-active');
          }
        });
      });
   
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.has-megamenu')) {
          megaMenus.forEach(menu => {
            menu.classList.remove('is-active');
            menu.closest('.has-megamenu')?.classList.remove('is-active');
          });
          activeMenu = null;
        }
      });
    }
  
    initMobileMenu() {
      if (!this.mobileMenuTrigger || !this.mobileMenu) return;
 
      this.backgroundBlur = document.createElement('div');
      this.backgroundBlur.classList.add('mobile_background_blur');
      document.body.appendChild(this.backgroundBlur);
 
      this.mobileMenuTrigger.addEventListener('click', () => {
        const isOpen = document.body.classList.contains('mobile-menu-open');
        if (!isOpen) {
          document.body.classList.add('mobile-menu-open');
          this.mobileMenu.classList.add('is-active');
          this.backgroundBlur.classList.add('is-active');
        } else {
          document.body.classList.remove('mobile-menu-open');
          this.mobileMenu.classList.remove('is-active');
          this.backgroundBlur.classList.remove('is-active');
        }
      });
 
      this.backgroundBlur.addEventListener('click', () => {
        document.body.classList.remove('mobile-menu-open');
        this.mobileMenu.classList.remove('is-active');
        this.backgroundBlur.classList.remove('is-active');
        this.submenus.forEach(submenu => {
          submenu.classList.remove('is-active');
        });
        document.body.style.overflow = ""; 
      });
 
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains('mobile-menu-open')) {
          this.closeMobileMenu();
        }
      });
    }

    closeMobileMenu() {
      document.body.classList.remove('mobile-menu-open');
      this.mobileMenu.classList.remove('is-active');
      this.backgroundBlur.classList.remove('is-active');
      this.submenus.forEach(submenu => {
        submenu.classList.remove('is-active');
      });
    }

    initCloseButtons() {
      
      if (this.mobileMenuClose) {
        this.mobileMenuClose.addEventListener('click', () => {
          this.closeMobileMenu();
        });
      }
 
      if (this.submenuClose) {
        this.submenuClose.forEach(closeBtn => {
          closeBtn.addEventListener('click', () => {
            this.closeMobileMenu();
          });
        });
      }
    }
  }
  
  if (typeof window !== 'undefined') {
    customElements.define('custom-header', class extends HTMLElement {
      constructor() {
        super();
        new CustomHeader();
      }
    });
  }
   
  document.addEventListener('DOMContentLoaded', () => {
    new CustomHeader();
  });
   
  function initMegaMenuSwiper() {
    const megaMenus = document.querySelectorAll('.mega-menu__swiper');
    
    megaMenus.forEach(menu => {
      new Swiper(menu, {
        slidesPerView: 7,
        spaceBetween: 20,
        navigation: {
          nextEl: menu.querySelector('.swiper-button-next'),
          prevEl: menu.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          480: {
            slidesPerView: 3,
            spaceBetween: 15
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 15
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 7,
            spaceBetween: 20
          }
        }
      });
    });
  }
  
 
  document.addEventListener('DOMContentLoaded', initMegaMenuSwiper); 



  document.addEventListener('DOMContentLoaded', () => {
    const accordionTriggers = document.querySelectorAll('.accordion-trigger');
    
    accordionTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        const currentContent = trigger.nextElementSibling;
         
        accordionTriggers.forEach(otherTrigger => {
          if (otherTrigger !== trigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
            const otherContent = otherTrigger.nextElementSibling;
            otherContent.style.maxHeight = '0';
            otherContent.style.opacity = '0';
          }
        });
         
        trigger.setAttribute('aria-expanded', !isExpanded);
        if (!isExpanded) {
          currentContent.style.maxHeight = currentContent.scrollHeight + 'px';
          currentContent.style.opacity = '1';
        } else {
          currentContent.style.maxHeight = '0';
          currentContent.style.opacity = '0';
        }
      });
    });
  });